import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import {
  FaCircleExclamation,
  FaWhatsapp,
  FaHeadset,
} from "react-icons/fa6";

/* ============================================
   KOMPONEN: Halaman Isolir / Terisolasi
   ============================================ */
export const IsolirPage = () => {
  // Menangkap query parameter (jika Mikrotik mengirimkan ID Pelanggan saat redirect)
  // Contoh URL: /isolir?id=001234567890
  const [searchParams] = useSearchParams();
  const idPel = searchParams.get("id") || "-";

  // Ganti dengan nomor WhatsApp admin/CS Anda
  const adminPhoneNumber = "6281234567890"; 
  const waMessage = encodeURIComponent(`Halo Admin, Saya pelanggan dengan ID: ${idPel}. Saya ingin menanyakan terkait internet saya yang saat ini diisolir. Terima kasih.`);
  const waLink = `https://wa.me/${adminPhoneNumber}?text=${waMessage}`;

  return (
    <>
      <Helmet>
        <title>Akses Diisolir - Radius Trend</title>
        <meta name="description" content="Koneksi internet Anda saat ini sedang diisolir. Silakan lakukan pembayaran atau hubungi admin." />
      </Helmet>

      {/* Background Utama */}
      <div 
        className="min-h-screen w-full flex items-center justify-center p-4 relative overflow-hidden"
        style={{ 
          background: "linear-gradient(135deg, #020617 0%, #0f172a 50%, #020617 100%)"
        }}
      >
        {/* Efek Blurred Orb di Background (Dekorasi) */}
        <div 
          className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-20 blur-3xl"
          style={{ background: "radial-gradient(circle, rgba(245, 158, 11, 0.4), transparent 70%)" }}
        />
        <div 
          className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full opacity-10 blur-3xl"
          style={{ background: "radial-gradient(circle, rgba(0, 180, 216, 0.4), transparent 70%)" }}
        />

        {/* Konten Utama */}
        <div className="w-full max-w-md relative z-10">
          
          {/* Card Utama */}
          <section
            className="rounded-2xl p-8 text-center"
            style={{
              background: "rgba(15, 23, 42, 0.6)",
              border: "1px solid rgba(51, 65, 85, 0.4)",
              backdropFilter: "blur(16px)",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)"
            }}
            aria-label="Informasi isolir pelanggan"
          >
            {/* Icon Warning */}
            <div 
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ 
                background: "rgba(245, 158, 11, 0.1)", 
                border: "1px solid rgba(245, 158, 11, 0.2)" 
              }}
            >
              <FaCircleExclamation className="text-4xl text-amber-400" />
            </div>

            {/* Heading */}
            <h1 className="text-2xl md:text-3xl font-bold text-gray-100 mb-2">
              Akses Internet Diisolir
            </h1>
            
            {/* Deskripsi */}
            <p className="text-sm text-slate-400 leading-relaxed mb-8">
              Saat ini koneksi internet Anda sedang dibatasi. 
              Hal ini biasanya terjadi karena terdapat tagihan yang belum terbayar atau ada kendala pada akun Anda.
            </p>

            {/* Box Info ID Pelanggan */}
            <div 
              className="rounded-xl p-4 mb-8"
              style={{ 
                background: "rgba(30, 41, 59, 0.5)", 
                border: "1px solid rgba(51, 65, 85, 0.3)" 
              }}
            >
              <p className="text-[10px] text-slate-500 uppercase font-semibold tracking-wider mb-1">
                ID Pelanggan
              </p>
              <p className="text-xl font-mono font-bold text-cyan-400">
                {idPel}
              </p>
            </div>

            {/* Tombol Aksi */}
            <div className="space-y-3">
              {/* Tombol WhatsApp Utama */}
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2.5 w-full py-3.5 px-4 rounded-xl font-semibold text-sm transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                style={{ 
                  background: "rgba(34, 197, 94, 0.15)", 
                  border: "1px solid rgba(34, 197, 94, 0.3)", 
                  color: "#4ade80" // green-400
                }}
              >
                <FaWhatsapp className="text-lg" />
                Hubungi Admin via WhatsApp
              </a>

              {/* Tombol Sekunder (Opsional) */}
              <button
                onClick={() => window.location.href = '/'} // Ganti dengan URL halaman login/info jika ada
                className="flex items-center justify-center gap-2 w-full py-3.5 px-4 rounded-xl font-semibold text-sm text-slate-400 transition-all duration-200 hover:text-slate-200 hover:bg-slate-700/30"
                style={{ 
                  background: "rgba(51, 65, 85, 0.2)", 
                  border: "1px solid rgba(51, 65, 85, 0.3)" 
                }}
              >
                <FaHeadset className="text-sm" />
                Halaman Utama
              </button>
            </div>
          </section>

          {/* Footer Text */}
          <p className="text-center text-xs text-slate-600 mt-6 font-medium">
            © {new Date().getFullYear()} Radius Trend ISP. All rights reserved.
          </p>
          
        </div>
      </div>
    </>
  );
};